import { InboxIcon, WorkflowIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useAuthStore } from '@/shared/auth/store';
import { normalizeQuery } from '@/shared/lib/strings';
import type { CommandItem } from '@/shared/registry/types';

import { useTaskCounters } from '../api';

/** Sidebar badge: how many tasks wait for the user (refreshed by `bizproc.tasks-changed`). */
export function useBizprocNavCounter(): number | undefined {
  const signedIn = useAuthStore((s) => s.status === 'authenticated');
  const open = useTaskCounters({ enabled: signedIn }).data?.open;
  return open && open > 0 ? open : undefined;
}

/** ⌘K: «My tasks» and «Running processes», shown while the query is empty or names them. */
export function useBizprocCommands(query: string): { items: CommandItem[] } {
  const { t } = useTranslation('bizproc');
  const counters = useTaskCounters();
  const search = normalizeQuery(query) ?? '';
  const open = counters.data?.open ?? 0;
  const items: CommandItem[] = [
    {
      id: 'bizproc:tasks',
      label: t('commands.tasks'),
      description: open > 0 ? t('commands.tasksWaiting', { count: open }) : undefined,
      icon: InboxIcon,
      keywords: [t('nav.title'), 'tasks', 'approval', 'задания', 'согласование', 'завдання', 'погодження'],
      to: '/bizproc/tasks',
    },
    {
      id: 'bizproc:instances',
      label: t('commands.instances'),
      icon: WorkflowIcon,
      keywords: [t('nav.title'), 'processes', 'running', 'процессы', 'запущенные', 'процеси', 'запущені'],
      to: '/bizproc/instances',
    },
  ];
  return { items: search.length === 0 || search.length >= 2 ? items : [] };
}
